import{gql as e}from"@apollo/client";import{PROJECT_SETTINGS_FRAGMENT as t}from"./projectSettings.fragment.js";import{PROJECT_THEME_FRAGMENT as i}from"./projectTheme.fragment.js";const o=e`
  fragment geladaProjectFragment on ProjectGraphType {
    backOfficeUrl
    description
    domain @include(if: $shouldIncludeProjectDomain) {
      redirectAfterLogin
      redirectAfterRegistration
      value
      website
    }
    features
    guid
    hasMobileApplication
    id
    isCustomBuild
    isDeactivated
    logo @include(if: $shouldIncludeProjectLogo) {
      assetId
      contentType
      presignedUrl
      s3Key
    }
    name
    isFavourite
    organisation {
      name
      key
      description
      id
      logo {
        assetId
        contentType
        presignedUrl
        s3Key
      }
    }
    organisationId
    services
    settings @include(if: $shouldIncludeProjectSettings) {
      ...projectSettingsFragment
    }
    theme @include(if: $shouldIncludeProjectTheme) {
      ...projectThemeFragment
    }
    url
  }

  ${t}

  ${i}
`;export{o as GELADA_PROJECT_FRAGMENT};
//# sourceMappingURL=geladaProject.fragment.js.map
